import React, { FC, useRef } from 'react';
import { getImage } from '../../../../app/utlis/imageConstants';
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';
import { motion, useInView } from 'framer-motion';

interface BitEuProjectContentProps {
  bitEuProject: any;
}

const BitEuProjectContent: FC<BitEuProjectContentProps> = ({
  bitEuProject,
}) => {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 0.2,
  });

  const containerAnimation = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
        duration: 0.5,
      },
    },
  };

  const itemAnimation = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  const iconAnimation = {
    hidden: {
      scale: 0.8,
      opacity: 0,
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
      <motion.div
        ref={containerRef}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        variants={containerAnimation}
        className="
          grid
          grid-cols-1
          md:grid-cols-2
          gap-4
          md:gap-6
          lg:gap-8
          py-8
          lg:py-16
          auto-rows-fr
        "
      >
        {bitEuProject?.bitEuProjectDetails?.AppDetails?.map(
          (detail: any, index: number) => {
            const img = getImage(detail?.image ?? '') ?? '';

            return (
              <motion.div
                key={index}
                variants={itemAnimation}
                className="h-full"
              >
                <motion.div
                  className="
                    bg-blackDark
                    p-4
                    sm:p-5
                    lg:p-6
                    rounded-3xl
                    flex
                    items-center
                    gap-4
                    w-full
                    h-full
                    min-h-[130px]
                  "
                  whileHover={{ scale: 1.02 }}
                  transition={{
                    type: 'spring',
                    stiffness: 400,
                    damping: 17,
                  }}
                >
                  <motion.div
                    variants={iconAnimation}
                    whileHover={{ rotate: [0, 10, -10, 0] }}
                    transition={{ duration: 0.5 }}
                    className="
                      w-14 h-14
                      sm:w-16 sm:h-16
                      lg:w-20 lg:h-20
                      min-w-[56px]
                      sm:min-w-[64px]
                      lg:min-w-[80px]
                      rounded-full
                      flex
                      items-center
                      justify-center
                      bg-biteuColor
                      flex-shrink-0
                    "
                  >
                    <div className="flex items-center justify-center">
                      <DynamicSVG color="#000">{img}</DynamicSVG>
                    </div>
                  </motion.div>

                  <div className="flex-1 min-w-0">
                    <h3
                      className="
                        text-base
                        sm:text-lg
                        lg:text-xl
                        font-semibold
                        text-white
                        leading-tight
                        break-words
                      "
                    >
                      {detail.title}
                    </h3>

                    <p
                      className="
                        text-sm
                        sm:text-base
                        text-[#E0E0E0]
                        mt-2
                        leading-relaxed
                        break-words
                      "
                    >
                      {detail.sub_title}
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            );
          }
        )}
      </motion.div>
    </section>
  );
};

export default BitEuProjectContent;